export const lang =
[
    {
        "ID": "1",
        "Key": "",
        "备注": "",
        "zh-CN": "活动规则",
        "字节限制": "15",
        "en": "Event Rules",
        "ar": "قواعد الفعالية",
        "fr": "Règles de l'événement",
        "de": "Eventregeln",
        "id": "Peraturan Event",
        "ja": "キャンペーンルール",
        "ko": "이벤트 설명",
        "pt": "Regras",
        "ru": "Правила события",
        "es": "Reglas evento",
        "th": "กฎอีเวนต์",
        "tr": "Etkinlik Kural",
        "vi": "Quy tắc sự kiện",
        "it": "Regole evento",
        "zh-TW": "活動規則"
    },
    {
        "ID": "2",
        "Key": "",
        "备注": "",
        "zh-CN": "1. 您有3次掷骰子并获得7周年庆礼物的机会。<p></p>2. 活动中，您有机会获得普通礼物和特别奖励！<p></p>3. 将周年庆活动页面分享至您的社交媒体主页，您将获得额外3次掷骰子机会！<p></p>4. 本次活动最终解释权归Habby所有。",
        "字节限制": "",
        "en": "1. You have 3 chances to the roll the dice for 7th Anniversary presents.<p></p>2. During the event, you'll get a chance to win ordinary gifts and special rewards!<p></p>3. Share the Anniversary Event page to your social media to earn 3 dice rolls!<p></p>4. Habby reserves all rights to final intepretation of this event.",
        "ar": "1. لديك 3 فرص لرمي النرد بهدف ربح هدايا الذكرى السنوية السابعة.<p></p>2. خلال الفعالية، ستحصل على فرصة لربح هدايا عادية ومكافآت خاصة!<p></p>3. شارك صفحة فعالية الذكرى السنوية على حساباتك على منصات التواصل الاجتماعي لربح 3 لفات للنرد!<p></p>4. تحتفظ شركة Habby بجميع الحقوق في الترجمة النهائية لهذه الفعالية.",
        "fr": "1. Vous avez 3 chances de lancer les dés pour obtenir des cadeaux du 7e anniversaire.<p></p>2. Au cours de cet événement, vous aurez la chance de gagner des cadeaux ordinaires et des récompenses spéciales !<p></p>3. Partagez la page de l'événement d'anniversaire sur vos réseaux sociaux pour gagner 3 lancers de dés !<p></p>4. Habby se réserve tous les droits d'interprétation finale de cet événement.",
        "de": "1. Du kannst 3-mal würfeln für Geschenke zum 7. Jahrestag.<p></p>2. Du hast während des Events die Chance, gewöhnliche Geschenke und besondere Belohnungen zu gewinnen!<p></p>3. Teile die Seite des Jahrestags-Events in den sozialen Medien, um 3 Würfelversuche zu erhalten!<p></p>4. Habby behält sich alle Rechte an der endgültigen Interpretation dieses Events vor.",
        "id": "1. Kamu memiliki 3 peluang untuk melempar dadu untuk hadiah Hari Jadi ke-7.<p></p>2. Selama event ini, kamu akan mendapatkan peluang memenangkan bingkisan biasa dan hadiah istimewa!<p></p>3. Bagikan halaman Event Hari Jadi ke media sosial kamu untuk mendapatkan 3 lemparan dadu!<p></p>4. Habby berhak menentukan hasil akhir dari event ini.",
        "ja": "1. サイコロを3回振って、7周年記念プレゼントを獲得するチャンスがあります。<p></p>2. キャンペーンでは通常プレゼントと特別報酬を獲得するチャンスがあります！<p></p>3. 周年記念キャンペーンページをSNSにシェアすると、追加で3回サイコロを振るチャンスをゲット！<p></p>4. 本キャンペーンの最終的な解釈権はHabbyに帰属します。",
        "ko": "1. 총 3번의 주사위를 돌릴 수 있고 7주년 선물을 받을 수 있는 기회를 얻습니다. <p></p>2.이벤트에서 일반 보상과 특별 보상을 받을 수 있는 기회가 주어집니다. <p></p>3. SNS에 이 주년 이벤트를 공유하면 주사위를 던질 수 있는 기회 3회를 더 얻습니다. <p></p>4. 이벤트 최종 해석권은 Habby에게 있습니다.",
        "pt": "1. Você tem 3 chances de jogar os dados para ganhar presentes do 7º Aniversário.<p></p>2. Durante o evento, você terá a chance de ganhar presentes comuns e recompensas especiais!<p></p>3. Compartilhe a página do Evento de Aniversário em suas redes sociais para ganhar 3 jogadas!<p></p>4. A Habby reserva todos os direitos de interpretação final do evento.",
        "ru": "1. У вас есть 3 шанса бросить кости и выиграть подарки в честь 7-летия.<p></p>2. Во время события у вас будет шанс выиграть обычные призы и особые награды!<p></p>3. Поделитесь страницей события в честь годовщины в соцсетях и выиграйте 3 броска костей!<p></p>4. Habby оставляет за собой все права на окончательную интерпретацию этого события.",
        "es": "1. Tienes 3 intentos para tirar el dado y ganar regalos del 7.º aniversario.<p></p>2. Durante el evento, tendrás la oportunidad de ganar regalos normales y recompensas especiales.<p></p>3. ¡Comparte la página del evento de aniversario en tus redes sociales para ganar 3 tiradas de dados!<p></p>4. Habby se reserva todos los derechos de interpretación final de este evento.",
        "th": "1. คุณมีโอกาส 3 ครั้งที่จะทอยลูกเต๋าเพื่อรับของขวัญครบรอบปีที่ 7<p></p>2. ในระหว่างอีเวนต์ คุณจะได้รับโอกาสหนึ่งครั้งเพื่อรับของขวัญธรรมดาและของขวัญพิเศษ!<p></p>3. แชร์หน้าอีเวนต์ครบรอบปีบนโซเชียลมีเดียของคุณเพื่อรับสิทธิ์ทอยลูกเต๋า 3 ครั้ง!<p></p>4. Habby ขอสงวนสิทธิ์ในการตีความขั้นสุดท้ายของอีเวนต์นี้",
        "tr": "1. 7. Yıl Dönümü hediyeleri için 3 zar atma hakkın var.<p></p>2. Etkinlik sırasında, sıradan hediyeler ve özel ödüller kazanma şansın olacak!<p></p>3. Yıl Dönümü Etkinliği sayfasını sosyal medyada paylaşarak 3 zar atma hakkı kazan!<p></p>4. Habby, bu etkinliğe son yorumu getirme hakkını saklı tutar.",
        "vi": "1. Bạn có 3 cơ hội tung xúc xắc để nhận thưởng Kỷ Niệm lần thứ 7.<p></p>2. Trong thời gian diễn ra sự kiện, bạn sẽ có cơ hội giành những phần thưởng cơ bản và đặc biệt!<p></p>3. Hãy chia sẻ trang Sự Kiện Kỷ Niệm lên mạng xã hội và nhận 3 lượt tung xúc xắc!<p></p>4. Habby bảo lưu tất cả quyền diễn giải cuối cùng cho sự kiện này.",
        "it": "1. Hai 3 tentativi di lancio dei dadi per ottenere regali del 7° Anniversario.<p></p>2. Durante l'evento, avrai la possibilità di vincere regali ordinari e premi speciali!<p></p>3. Condividi la pagina dell'evento Anniversario sui tuoi social per ottenere altri 3 lanci di dadi!<p></p>4. Habby si riserva tutti i diritti sull'interpretazione finale di questo evento.",
        "zh-TW": "1. 您有3次擲骰子並獲得7周年慶禮物的機會。<p></p>2. 活動中，您有機會獲得普通禮物和特別獎勵！<p></p>3. 將周年慶活動頁面分享至您的社交媒體主頁，您將獲得額外3次擲骰子機會！<p></p>4. 本次活動最終解釋權歸Habby所有。"
    },
    {
        "ID": "3",
        "Key": "",
        "备注": "",
        "zh-CN": "恭喜你获得了:",
        "字节限制": "35",
        "en": "Congrats! You won:",
        "ar": "تهانينا! ربحت:",
        "fr": "Félicitations ! Vous avez gagné :",
        "de": "Glückwunsch! Du gewinnst:",
        "id": "Selamat! Kamu memenangkan:",
        "ja": "おめでとうございます！以下のアイテムを獲得しました。",
        "ko": "축하합니다, 획득하셨습니다:",
        "pt": "Parabéns! Você ganhou:",
        "ru": "Поздравляем! Ваш выигрыш:",
        "es": "¡Felicidades! Has ganado:",
        "th": "ยินดีด้วย! คุณได้รับ:",
        "tr": "Tebrikler! Kazandıkların:",
        "vi": "Xin chúc mừng! Bạn đã thắng:",
        "it": "Congratulazioni! Hai vinto:",
        "zh-TW": "恭喜你獲得了:"
    },
    {
        "ID": "4",
        "Key": "",
        "备注": "",
        "zh-CN": "请收下雅典娜的周年庆礼物！",
        "字节限制": "50",
        "en": "Please accept Anniversary present from Athena!",
        "ar": "يُرجى قبول هدية الذكرى السنوية من أثينا!",
        "fr": "Acceptez le cadeau d'anniversaire d'Athena !",
        "de": "Bitte nimm das Jahrestagsgeschenk von Athena an!",
        "id": "Harap terima hadiah Hari Jadi dari Athena!",
        "ja": "アテナからの周年記念プレゼントをお受け取りください！",
        "ko": "아테나의 주년 선물을 받으세요!",
        "pt": "Aceite o presente de Aniversário da Athena!",
        "ru": "Примите подарок в честь годовщины от Афины!",
        "es": "¡Acepta el regalo de aniversario de Atenea!",
        "th": "โปรดรับของขวัญครบรอบจากอาธีน่าด้วย!",
        "tr": "Lütfen Athena'nın Yıl Dönümü hediyesini kabul et!",
        "vi": "Hãy Nhận Quà Kỷ Niệm Từ Athena!",
        "it": "Accetta il regalo dell'Anniversario da Athena!",
        "zh-TW": "請收下雅典娜的周年慶禮物！"
    },
    {
        "ID": "5",
        "Key": "",
        "备注": "自动换行",
        "zh-CN": "分享周年庆活动到社交媒体主页，并获得更多掷骰子机会！",
        "字节限制": "/",
        "en": "Share the Anniversary Event to your social media and earn more dice rolls!",
        "ar": "شارك فعالية الذكرى السنوية على حساباتك على منصات التواصل الاجتماعي واربح المزيد من لفات النرد!",
        "fr": "Partagez l'événement d'anniversaire sur vos réseaux sociaux pour gagner plus de lancers de dés !",
        "de": "Teile das Jahrestagsevent in den sozialen Medien, um mehr Würfelversuche zu erhalten!",
        "id": "Bagikan Event Hari Jadi ke media sosial kamu dan dapatkan lebih banyak lemparan dadu!",
        "ja": "周年記念キャンペーンをSNSにシェアすると、追加でサイコロを振るチャンスをゲット！",
        "ko": "주년 이벤트를 SNS에 공유하고 더 많은 주사위 굴리기 기회를 얻으세요!",
        "pt": "Compartilhe o evento de Aniversário em suas redes sociais para ganhar mais jogadas!",
        "ru": "Поделитесь событием в честь годовщины в соцсетях и выиграйте больше бросков костей!",
        "es": "¡Comparte el evento de aniversario en tus redes sociales y gana más tiradas de dados!",
        "th": "แชร์อีเวนต์ครบรอบปีบนโซเชียลมีเดียของคุณเพื่อรับสิทธิ์ทอยลูกเต๋าเพิ่ม!",
        "tr": "Yıl Dönümü Etkinliğini sosyal medyada paylaş ve daha çok zar hakkı kazan!",
        "vi": "Hãy chia sẻ Sự Kiện Kỷ Niệm lên mạng xã hội của bạn và kiếm thêm xúc xắc!",
        "it": "Condividi l'evento Anniversario sui tuoi social per ottenere altri lanci di dadi!",
        "zh-TW": "分享周年慶活動到社交媒體主頁，並獲得更多擲骰子機會！"
    },
    {
        "ID": "6",
        "Key": "",
        "备注": "",
        "zh-CN": "直接领取",
        "字节限制": "20",
        "en": "Skip and Claim",
        "ar": "تخطي واستلام",
        "fr": "Passer et récupérer",
        "de": "Überspringen und abholen",
        "id": "Lewati dan Klaim",
        "ja": "受け取る",
        "ko": "바로 수령",
        "pt": "Pular e pegar",
        "ru": "Пропустить и забрать",
        "es": "Saltar y reclamar",
        "th": "ข้ามและเคลม",
        "tr": "Atla ve Al",
        "vi": "Bỏ qua và nhận",
        "it": "Salta e riscatta",
        "zh-TW": "直接領取"
    },
    {
        "ID": "7",
        "Key": "",
        "备注": "",
        "zh-CN": "复制礼品码",
        "字节限制": "20",
        "en": "Copy Gift Code",
        "ar": "نسخ رمز الهدية",
        "fr": "Copier le code cadeau",
        "de": "Geschenkcode kopieren",
        "id": "Salin Kode Hadiah",
        "ja": "シリアルをコピー",
        "ko": "기프트코드 복사",
        "pt": "Copiar cód. presente",
        "ru": "Копир. подар. код",
        "es": "Copiar código regalo",
        "th": "คัดลอกรหัสของขวัญ",
        "tr": "Ödül Kodunu Kopyala",
        "vi": "Sao chép mã quà",
        "it": "Copia codice regalo",
        "zh-TW": "複製禮品碼"
    },
    {
        "ID": "8",
        "Key": "",
        "备注": "",
        "zh-CN": "点此兑换",
        "字节限制": "25",
        "en": "Tap here to exchange",
        "ar": "انقر هنا للاستبدال",
        "fr": "Appuyez ici pour échanger",
        "de": "Tippe hier zum Tauschen",
        "id": "Ketuk di sini untuk tukar",
        "ja": "引き換えはこちら",
        "ko": "클릭하여 교환",
        "pt": "Toque aqui para trocar",
        "ru": "Коснитесь для обмена",
        "es": "Toca para intercambiar.",
        "th": "แตะที่นี่เพื่อแลกเปลี่ยน",
        "tr": "Takas için buraya dokun",
        "vi": "Nhấp vào đây để đổi",
        "it": "Tocca qui per scambiare",
        "zh-TW": "點此兌換"
    },
    {
        "ID": "9",
        "Key": "礼包码复制",
        "备注": "礼包码已复制成功，快去兑换大奖！",
        "zh-CN": "礼包码已复制成功，快去兑换大奖！",
        "字节限制": "",
        "en": "The Reward Code has been copied successfully, go and redeem it!",
        "ar": "تم نسخ رمز المكافأة بنجاح، اذهب لاسترداده!",
        "fr": "Le code de récompense a été copié avec succès, allez l'échanger !",
        "de": "Der Geschenkcode wurde erfolgreich kopiert, jetzt loslegen und einlösen!",
        "id": "Kode Imbalan berhasil disalin, ayo tukarkan!",
        "ja": "報酬コードがコピーされました。今すぐ報酬を受け取りましょう！",
        "ko": "기프트 코드가 성공적으로 복사되었습니다. 가서 상품을 사용하세요!",
        "pt": "O Código de Recompensa foi copiado com sucesso, vá usar ele!",
        "ru": "Код награды скопирован; обменяйте его!",
        "es": "¡El código de recompensa se copió correctamente, ve a canjearlo!",
        "th": "คัดลอกรหัสรางวัลสำเร็จแล้ว ไปแลกรับเลย!",
        "tr": "Ödül Kodu başarıyla kopyalandı, git ve kullan!",
        "vi": "Đã sao chép Mã Phần Thưởng thành công, mau đến và đổi mã nào!",
        "it": "Il Codice premio è stato copiato con successo; vai a riscattarlo!",
        "zh-TW": "禮包碼已復製成功，快去兌換大獎！"
    },
    {
        "ID": "10",
        "Key": "",
        "备注": "",
        "zh-CN": "",
        "字节限制": "",
        "en": "",
        "ar": "",
        "fr": "",
        "de": "",
        "id": "",
        "ja": "",
        "ko": "",
        "pt": "",
        "ru": "",
        "es": "",
        "th": "",
        "tr": "",
        "vi": "",
        "it": "",
        "zh-TW": ""
    },
    {
        "ID": "11",
        "Key": "",
        "备注": "",
        "zh-CN": "更多超值礼包",
        "字节限制": "",
        "en": "More Value Packs",
        "ar": "المزيد من العروض",
        "fr": "Plus de promos",
        "de": "Mehr Angebote",
        "id": "Lebih banyak diskon",
        "ja": "お得なパックセール",
        "ko": "특가 패키지 세일",
        "pt": "Mais ofertas",
        "ru": "Больше скидок",
        "es": "Más ofertas",
        "th": "ส่วนลดเพิ่มเติม",
        "tr": "Daha fazla indirim",
        "vi": "Thêm ưu đãi",
        "it": "Più offerte",
        "zh-TW": "更多超值禮包"
    },
    {
        "ID": "12",
        "Key": "",
        "备注": "",
        "zh-CN": "",
        "字节限制": "",
        "en": "",
        "ar": "",
        "fr": "",
        "de": "",
        "id": "",
        "ja": "",
        "ko": "",
        "pt": "",
        "ru": "",
        "es": "",
        "th": "",
        "tr": "",
        "vi": "",
        "it": "",
        "zh-TW": ""
    },
    {
        "ID": "",
        "Key": "",
        "备注": "",
        "zh-CN": "",
        "字节限制": "",
        "en": "",
        "ar": "",
        "fr": "",
        "de": "",
        "id": "",
        "ja": "",
        "ko": "",
        "pt": "",
        "ru": "",
        "es": "",
        "th": "",
        "tr": "",
        "vi": "",
        "it": "",
        "zh-TW": ""
    },
    {
        "ID": "",
        "Key": "",
        "备注": "",
        "zh-CN": "",
        "字节限制": "",
        "en": "",
        "ar": "",
        "fr": "",
        "de": "",
        "id": "",
        "ja": "",
        "ko": "",
        "pt": "",
        "ru": "",
        "es": "",
        "th": "",
        "tr": "",
        "vi": "",
        "it": "",
        "zh-TW": ""
    },
    {
        "ID": "",
        "Key": "说明页",
        "备注": "",
        "zh-CN": "",
        "字节限制": "分享页",
        "en": "",
        "ar": "",
        "fr": "结果页一行",
        "de": "",
        "id": "",
        "ja": "",
        "ko": "",
        "pt": "",
        "ru": "",
        "es": "",
        "th": "",
        "tr": "",
        "vi": "",
        "it": "",
        "zh-TW": ""
    }
]



// WEBPACK FOOTER //
// ./src/tool/archeroLang.js